import { Component, Input, OnInit } from '@angular/core';

@Component({
	selector: 'app-dashlist',
	templateUrl: './dashlist.component.html',
	styleUrls: ['./dashlist.component.scss']
})
export class DashListComponent implements OnInit {
	@Input() title: string;
	@Input() list: Array<object>;
	@Input() fa_icon = 'fa-line-chart';
	constructor() { }
	ngOnInit() { }
}
